<template>
  <section>
     <span @click="showModalAddVersionDocument">
      <slot></slot>
    </span>    

    <b-modal v-model="modalAddVersionDocument" size="lg" centered no-fade>
      <div slot="modal-header" class="w-100">{{ $t('TEMPLATES.ADD_VERSION.TITLE') }}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEMPLATES.ADD_VERSION.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">

          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEMPLATES.ADD_VERSION.INPUT_VERSION') }}</label>
            <input
              class="form-control"
              v-model.number="addFormVersion"
              type="number"
              name="name"
              required
            />
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEMPLATES.ADD_VERSION.INPUT_PUBLISH')">
              <b-form-radio-group id="addFormPublish" v-model="addFormPublish" name="publish">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
      
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
        <b-button
          variant="primary"
          class="btn-fill"
          @click="addDocumentVersion"
        >{{ $t('TEMPLATES.ADD_VERSION.ADD')}}</b-button>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["item","documentVersion","document"],
  data() {
    return {
      modalLoading: false,
      modalAddVersionDocument: false,
      addFormVersion: this.documentVersion.version,
      addFormDocument: "",
      addFormPublish: 0,
      addFormPublic: this.document.public
    };
  },
  methods: {
    getVersion: function() {
      let self = this;
      this.$http
        .get(process.env.VUE_APP_BACKEND + `/document/version/getnumber`, {
          params: {
            version: this.documentVersion.version
          }
        })
        .then(function(response) {
          self.addFormVersion = response.data.versionNumber;
        })
        .catch(function(error) {
          self.$noty.error(self.$t(error.response.data));
        });
    },
    hideModals: function() {
      this.modalAddVersionDocument = false;
      this.modalLoading = false;
    },
    showModalAddVersionDocument: function() {
      this.getVersion();
      this.modalAddVersionDocument = true;
    },
    addDocumentVersion: function() {
      let self = this;
      this.modalLoading = true;
       this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/version/add", {
          documentId: this.item.template.id,
          publish: parseInt(this.addFormPublish),
          public: this.addFormPublic,
          version: this.addFormVersion
        })
        .then(function(response) {
          self.hideModals();
          self.$emit("update",{ document: response.data.document, documentVersion: response.data.documentVersion });
          if (self.addFormPublish === 0) {
            self.$noty.info(self.$t("TEMPLATES.ADD_VERSION.SUCCESS.CREATED_DRAFT"));            
          } else {
            self.$noty.info(self.$t("TEMPLATES.ADD_VERSION.SUCCESS.CREATED_PUBLISH"));
          }
        })
        .catch(function(error) {          
          self.$noty.error(self.$t(error.response.data));
          self.modalLoading = false;
        });
    }
  },
  computed: {
    teamId() {
      return this.$store.getters["auth/teamId"];
    }
  },
  mounted: function() {
    this.getVersion();
  }
};
</script>
<style>
</style>